<template>
  <div class="head flex bsb">
    <div v-if="!flag" class="tab btn" @click="clickRecharge"> <img src="@/img/jinbi.png" alt=""> {{ $t('header.topUp') }}</div>
    <div style="flex: auto;"></div>
    <img src="@/img/yay-icon.svg" class="yay_icon" @click="router.push('/')">
  </div>
</template>

<script setup>
import router from '#/router'
import { ref } from 'vue'
const prop = defineProps({
  no_recharge: {
    type: Boolean,
    default: false
  }
})

const flag = ref(prop.no_recharge)

function clickRecharge() {
  const params = { text: '1aaaa', message: 1111 }
  router.push({ name: 'recharge', state: { params } })
}
</script>

<style lang="scss" scoped>
.head {
  width: 100vw;
  height: 48px;
  // box-shadow: 1px 3px 3px #eee;
  background: #fff;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  align-items: center;
  flex-direction: row-reverse;
  padding: 0 16px;
  z-index: 10;

  .tab {
    margin: 0 10px;
    color: #333;
    font-weight: 600;
  }

  .btn {
    padding: 5px 10px;
    border: 1px solid #ccc;
    border-radius: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;

    img {
      width: 18px;
      height: 18px;
      margin: 0 5px;
      margin-left: 0;
    }
  }

  .btn:hover {
    background: linear-gradient(rgba(72, 67, 254, 0.1), rgba(255, 95, 177, 0.1))
  }

  .yay_icon {
    height: 30px;
    cursor: pointer;
  }

}
</style>